import { RcClasses, spacing } from '../../../../../foundation';
export var RcTimePickerUtils = {
    small: {
        width: '160px',
        height: '160px',
        timeSystem: {
            margin: spacing(1),
        },
    },
    medium: {
        width: '272px',
        height: '208px',
        timeSystem: {
            margin: spacing(6),
        },
    },
};
export var RcTimePickerIconWidths = {
    small: { s12: '40px', s24: '24px' },
    medium: { s12: '56px', s24: '24px' },
};
export var RcTimePickerClasses = RcClasses(['popover', 'popoverPaper'], 'RcTimePicker');
